import PrintHeader from './PrintHeader';
import PrintFooter from './PrintFooter';

const PrintLayout = ({ children, headerFooterInfo }) => {
  return (
    <>
      <PrintHeader headerFooterInfo={headerFooterInfo} />
      {children}
      <PrintFooter headerFooterInfo={headerFooterInfo} />
    </>
  );
};

export default PrintLayout;
